/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* gebruikers.ts
* 3-12-2019 - Jelmer Jellema - Spin in het Web B.V.
* Nog zonder modellen
*/

import {Component} from '@angular/core';
import {DatatableDef} from 'sihw-ng/datatable/datatable.component';
import {Datatablescherm} from '../abstracts/datatablescherm.class';
import {Werkmaatschappij} from '../../models/werkmaatschappij';
import {hash} from '../../app/types';
import {Gebruiker} from '../../models/gebruiker';
import {Datarecords} from '../../services/api/api.service';

@Component({
  selector: 'scherm-gebruikers',
  templateUrl: './gebruikers.html',
  // styleUrls: ['./gebruikers.scss']
})
export class Gebruikersscherm extends Datatablescherm {
  _starttitle = 'Gebruikers';
  icon = 'fas fa-users';
  editscherm = 'Gebruikeredit';
  tableQuery = {
    table: 'gebruiker',
    connected: [
      {
        table: 'groep',
        attributes: ['groep']
      },
      {
        table: 'gebruiker_werkmaatschappij'
      },
      {
        table: 'leverancier',
        attributes: ['naam']
      },
      {
        table: 'gebruiker_project'
      }
    ]
  };
  werkmaatschappijen: hash<Werkmaatschappij> = {};

  /**
   * Overwrite, even snel de lookups halen voordat de tabel er is
   */
  async ngOnInit() {
    //check op toegang
    if (!this.api.userdata?.app_admin) {
      setTimeout(() => this.closeWindow(null, true), 200); //even lang genoeg zodat er niks van alles misgaat met een breedte 0 etc.
      return;
    }
    //haal de werkmaatschappijen op
    this.werkmaatschappijen = await Werkmaatschappij.getLookup(Gebruiker);
    super.ngOnInit();
  }

  protected async afterHaaldata(): Promise<void> {
    await super.afterHaaldata();
    //we maken de werkmaatschappijstrings 1 keer
    for (let rij of <Datarecords> this.tableData) {
      let wms = rij.gebruiker_werkmaatschappij.map(gw => this.werkmaatschappijen[gw.werkmaatschappij_id]?.afkorting || '?');
      wms.sort();
      rij.werkmaatschappijen = wms.join(', ');
    }
  }


  /////////////////////////////////tabledef //////////////////
  //public, anders klaagt AOT in production over het template
  public readonly tableDefinition: DatatableDef = {
    track: 'id',
    standaardsortering: {
      key: 'gebruikersnaam',
      richting: 1
    },
    velden: {
      werkmaatschappijen: {
        label: 'Werkmaatschappij',
      },
      gebruikersnaam: {
        label: 'E-mail'
      },
      naam: {
        label: 'Naam'
      },
      groep: {
        label: 'Groep',
        prop: 'groep.groep',
        type: 'enum'
      },
      leverancier: {
        label: 'Leverancier',
        prop: 'leverancier.naam'
      },
      actief: {
        label: 'Actief',
        type: 'bool',
        standaardfilter: 1
      },
      app_admin: {
        label: 'Appadmin',
        type: 'bool'
      },
      exact_admin: {
        label: 'Exactadmin',
        type: 'bool'
      }
    }
  };

  //constructor ivm injection
  constructor() {
    super('debug');
  }
}
